<template>
  <RFR26CodePostalDialog />
  <Atlantic27CodePostalDialog />
</template>

<script>
import RFR26CodePostalDialog from "@/components/Home/RFR26/RFR26CodePostalDialog.vue";
import Atlantic27CodePostalDialog from "@/components/Home/ATLANTIC27/Atlantic27CodePostalDialog.vue";

export default {
  components: { RFR26CodePostalDialog, Atlantic27CodePostalDialog },
};
</script>
